import React, { useEffect, useState } from 'react';
import { translations } from './i18n';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [lang, setLang] = useState('cy');
  const t = translations[lang];

  useEffect(() => {
    document.documentElement.lang = lang === 'cy' ? 'el' : 'en';
  }, [lang]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 font-body text-ink antialiased">
      <Header lang={lang} setLang={setLang} t={t.header} />
      <main>
        <Hero t={t.hero} />
        <Features t={t.features} />
        <HowItWorks t={t.howItWorks} />
        <Benefits t={t.benefits} />
        <CTA t={t.cta} />
      </main>
      <Footer t={t.footer} />
    </div>
  );
}

export default App;
